import { TableColumn } from '../../../../../../../../config/types';

export const columnsDesktop: TableColumn[] = [
  { name: 'product', label: 'PRODUCT', align: 'left', colWidth: '50%', sticky: true },
  { name: 'units', label: 'UNITS', align: 'right' },
  { name: 'unit_price_with_tax', label: 'UNIT_PRICE_WITH_TAX', align: 'right' },
  // { name: 'tax', label: 'TAX', align: 'right' },
  { name: 'amount_with_tax', label: 'AMOUNT_WITH_TAX', align: 'right' },
  { name: 'more_actions', label: '', align: 'right', colWidth: '12px' },
];
export const columnsMobile: TableColumn[] = [
  { name: 'product', label: 'PRODUCT', align: 'center', sticky: true },
  { name: 'status', label: 'STATUS', align: 'center' },
  { name: 'units', label: 'UNITS', align: 'center' },
  { name: 'unit_price_with_tax', label: 'UNIT_PRICE_WITH_TAX', align: 'center' },
  // { name: 'tax', label: 'TAX', align: 'center' },
  { name: 'amount_with_tax', label: 'AMOUNT_WITH_TAX', align: 'center' },
  { name: 'more_actions', label: '', align: 'center', colWidth: '12px' },
];
